import React from 'react';
import { GiClover } from 'react-icons/gi';
import { SiDoordash, SiGrubhub, SiSquare, SiUbereats } from 'react-icons/si';
import { ReactComponent as AiriWheelsIcon } from "../icons/AiriWheelsIcon.svg";
import { DSCVRY_LOGO_URL } from '../utils/contactBuilder';

type IntegrationLogoProps = {
  integrationId: string;
  className?: string;
};

/** Accessible, brand-specific mark used by the My Business integrations catalog. */
const IntegrationLogo: React.FC<IntegrationLogoProps> = ({ integrationId, className = 'h-8 w-8' }) => {
  const title = `${integrationId.replace('_', ' ')} logo`;
  if (integrationId === 'square') return <SiSquare aria-label={title} className={className} />;
  if (integrationId === 'clover') return <GiClover aria-label={title} className={`${className} text-[#00A862]`} />;
  if (integrationId === 'doordash') return <SiDoordash aria-label={title} className={`${className} text-[#FF3008]`} />;
  if (integrationId === 'uber_eats') return <SiUbereats aria-label={title} className={`${className} text-[#06C167]`} />;
  if (integrationId === 'grubhub') return <SiGrubhub aria-label={title} className={`${className} text-[#F63440]`} />;
  if (integrationId === 'dscvry') {
    return <img src={DSCVRY_LOGO_URL} alt="DSCVRY logo" className={`${className} object-contain`} />;
  }

  return (
    <AiriWheelsIcon aria-label="AiriWheels logo" className={className} />
  );
};

export default IntegrationLogo;
